<template>
    <b-row>
        <b-col sm="12" md="12" lg="12" xl="12">
            <b-card no-body>
                <b-card-body>
                    <h4 class="heading-1 mb-4">
                        <span>
                            Feriado
                        </span>
                        <div class="float-right">
                            <span class="text-primary">
                                <i
                                    class="fa fa-refresh fa-lg icon-button"
                                    title="Atualizar"
                                    @click.stop="obterFeriado()"
                                ></i>
                            </span>
                        </div>
                    </h4>
                    <app-erros-box
                        :erros="erros"
                        v-if="erros.length > 0"
                    ></app-erros-box>
                    <b-row>
                        <b-col sm="12" v-if="feriado">
                            <app-k-v titulo="Nome" :md="md" :lg="lg" :xl="xl">
                                <strong> 
                                    {{feriado.descricao}} 
                                </strong>
                            </app-k-v>
                            <app-k-v titulo="Data" :md="md" :lg="lg" :xl="xl">
                                <strong>
                                    {{ feriado.dataFeriado ? $moment(feriado.dataFeriado).format('DD/MM/YYYY') : '' }}
                                </strong>
                            </app-k-v>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" v-if="feriado" class="mt-2">
                            <app-btn-voltar
                                rota="Feriados"
                            ></app-btn-voltar>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import FeriadosServicos from './FeriadosServicos'

export default {
    data() {
        return {
            erros: [],
            xl: 1,
            lg: 1,
            md: 1,
            feriado: null
        }
    },

    methods: {
        obterFeriado() {
            this.$store.dispatch('addRequest')
            FeriadosServicos.obterPorId(this.$route.params.feriadoId).then((response) => {
                if (response) {
                    if (response.success) {
                        this.feriado = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterFeriado()
    },

}
</script>